import { render, staticRenderFns } from "./DeleteUser.vue?vue&type=template&id=a347cdc2&scoped=true"
import script from "./DeleteUser.vue?vue&type=script&lang=js"
export * from "./DeleteUser.vue?vue&type=script&lang=js"
import style0 from "./DeleteUser.vue?vue&type=style&index=0&id=a347cdc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a347cdc2",
  null
  
)

export default component.exports